import React from 'react';
import { ColorPalette } from '../../styles/constants';
import { Box, Typography, SxProps } from '@mui/material';
import { TaskAlt } from '@mui/icons-material';

interface ReportsWorktimeDisplayProps {
  projectFilter: string | null;
  loggedHours: number;
  workingHours: number;
  showLogged?: boolean;
  sx?: SxProps;
}

const styles = {
  workedTime: {
    fontSize: '14px',
    display: 'inline-flex',
    alignItems: 'center',
    color: ColorPalette.DARK_GRAY,
    mr: 2,
  },
  workedTimeWarning: {
    fontSize: '14px',
    display: 'inline-flex',
    alignItems: 'center',
    color: ColorPalette.WARNING_RED,
    mr: 2,
  },
  workedTimeFulfilled: {
    display: 'inline-flex',
    alignItems: 'center',
    mr: 2,
  },
};

export function ReportsEmployeeWorktime({
  loggedHours,
  projectFilter,
  workingHours,
  showLogged = false,
  sx,
}: ReportsWorktimeDisplayProps): JSX.Element {
  if (projectFilter) {
    return (
      <Typography sx={{ ...styles.workedTime, ...sx }}>
        {loggedHours}h
      </Typography>
    );
  } else {
    return workingHours.toFixed() === loggedHours.toFixed() ? (
      <Box sx={{ ...styles.workedTimeFulfilled, ...sx }}>
        <TaskAlt color="primary" />
      </Box>
    ) : (
      <Typography sx={{ ...styles.workedTimeWarning, ...sx }}>{`${
        showLogged ? 'Logged:' : ''
      } ${loggedHours}/${workingHours}h`}</Typography>
    );
  }
}
